import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModalConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
  type?: 'confirm' | 'info' | 'warning' | 'error';
}

export interface ModalState {
  isVisible: boolean;
  config: ModalConfig | null;
  onConfirm?: () => void;
  onCancel?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class CustomModalService {
  private modalState = new BehaviorSubject<ModalState>({
    isVisible: false,
    config: null
  });

  public modalState$ = this.modalState.asObservable();

  confirm(config: ModalConfig): Promise<boolean> {
    return new Promise((resolve) => {
      this.modalState.next({
        isVisible: true,
        config: {
          ...config,
          confirmText: config.confirmText || 'Confirm',
          cancelText: config.cancelText || 'Cancel',
          type: config.type || 'confirm'
        },
        onConfirm: () => {
          this.close();
          resolve(true);
        },
        onCancel: () => {
          this.close();
          resolve(false);
        }
      });
    });
  }

  info(config: Omit<ModalConfig, 'type'>) {
    this.modalState.next({
      isVisible: true,
      config: {
        ...config,
        confirmText: 'OK',
        type: 'info'
      },
      onConfirm: () => this.close()
    });
  }

  close() {
    this.modalState.next({
      isVisible: false,
      config: null
    });
  }
}
